<script setup>
import { ref, computed, watch } from 'vue';
import { isEmpty } from 'lodash';

/*
Este componente tiene el input para el IBAN pero detecta si es extranjero
o español y muestra el campo para introducir el BIC/SWIFT
OJO!!!! No funciona con v-model, simplemente mantiene el valor en los inputs
del formulario. Cuando lo pasemos a Vue 3 ya podríamos hacerlo mejor
 */
const props = defineProps({
  namespace: { type: String, default: '' },
  iban: { type: String, default: '' },
  bic: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
});

const ibanInterno = ref(props.iban);
const bicInterno = ref(props.bic);

const mostrarBic = computed(() => {
  return ibanInterno.value.length > 2 && !ibanInterno.value.startsWith('ES');
});

const name = (campo) => {
  if (isEmpty(props.namespace)) {
    return campo;
  }
  return `${props.namespace}[${campo}]`;
};

const cambiaCampo = (nombre, valor) => {
  const nuevoValor = valor.toUpperCase().replace(/\s/g, '');
  if (nombre === 'iban') {
    ibanInterno.value = nuevoValor;
  } else {
    bicInterno.value = nuevoValor;
  }
};

watch(
  () => mostrarBic.value,
  (valor) => {
    if (!valor) {
      bicInterno.value = '';
    }
  },
);
</script>

<template>
  <div class="cifra-input-iban">
    <div class="form-group">
      <label class=" control-label" for="cifra_input_iban_iban">
        IBAN
      </label>
      <input
        type="text"
        class="form-control iban"
        :name="name('iban')"
        :disabled="disabled"
        :value="ibanInterno"
        @input="cambiaCampo('iban', $event.target.value)"
      />
    </div>
    <div v-show="mostrarBic" class="form-group">
      <label class=" control-label" for="cifra_input_iban_iban">
        BIC/SWIFT
      </label>
      <input
        type="text"
        class="form-control bic"
        :name="name('bic')"
        :disabled="disabled"
        :value="bicInterno"
        @input="cambiaCampo('bic', $event.target.value)"
      />
    </div>
  </div>
</template>
